export const clubsIntro = 'Beyond the classroom, our clubs and societies give every learner somewhere to ' +
  'explore an interest, lead a team and build the confidence that carries into adult life.'

export const clubs = [
  { id: 1, name: 'Debate and Public Speaking', desc: 'Weekly debates and inter-school public speaking competitions.' },
  { id: 2, name: 'Science and Innovation Club', desc: 'Practical experiments, science fairs and innovation projects.' },
  { id: 3, name: 'Computer and Robotics Club', desc: 'Coding, robotics builds and digital skills for all levels.' },
  { id: 4, name: 'Environmental Club', desc: 'Tree planting, clean-up campaigns and conservation projects.' },
  { id: 5, name: 'Drama and Theatre Club', desc: 'Productions, poetry and performance for school events.' },
  { id: 6, name: 'Music and Choir', desc: 'Choir, instrumental tuition and performances at school occasions.' },
  { id: 7, name: 'Traditional Dance Club', desc: 'Celebrating our national heritage through dance and drumming.' },
  { id: 8, name: 'Art and Design Club', desc: 'Drawing, painting and design work exhibited around the school.' },
  { id: 9, name: 'Journalism and Media Club', desc: 'The school newsletter, photography and event coverage.' },
  { id: 10, name: 'Christian Union', desc: 'Fellowship, worship and service rooted in our Christian values.' },
  { id: 11, name: 'Interact and Community Service', desc: 'Outreach projects supporting our surrounding community.' },
  { id: 12, name: 'Entrepreneurship Club', desc: 'Business skills, enterprise projects and financial literacy.' }
]

export const outingsAndCommemorations = [
  { id: 1, name: 'Africa Day', desc: 'A whole school celebration of African culture, dress, food and music.' },
  { id: 2, name: 'Independence Day', desc: 'Commemorating our national heritage with learners and staff.' },
  { id: 3, name: 'Educational Tours', desc: 'Trips to universities, museums, industry and national heritage sites.' },
  { id: 4, name: 'Sports and Cultural Galas', desc: 'Inter-house galas bringing families and the community together.' },
  { id: 5, name: 'Prize Giving Day', desc: 'Recognising academic, sporting and service achievement each year.' },
  { id: 6, name: 'Community Outreach Days', desc: 'Learner-led service projects with local schools and homes.' }
]

// Photographs of club activities, outings and commemorations. Add entries as
// { id, image, caption } and the gallery renders automatically; while the list
// is empty the gallery section is hidden.
export const clubsGallery = []
